function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "computer"
}, /*#__PURE__*/React.createElement("path", {
  d: "m19 3h-14c-1.654 0-3 1.346-3 3v8c0 1.654 1.346 3 3 3h4v2h-1c-.552 0-1 .447-1 1s.448 1 1 1h8c.553 0 1-.447 1-1s-.447-1-1-1h-1v-2h4c1.654 0 3-1.346 3-3v-8c0-1.654-1.346-3-3-3zm-6 16h-2v-2h2zm7-5c0 .552-.448 1-1 1h-14c-.551 0-1-.448-1-1v-8c0-.552.449-1 1-1h14c.552 0 1 .448 1 1z"
}));

var Svg033Computer = function Svg033Computer(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg033Computer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/033-computer.575c201b.svg";
export { ForwardRef as ReactComponent };